let t = 0;
function r(e = "") {
  return `${e}${t++}`;
}
export {
  r as createUUID
};
